var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarYellowHalf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0157 17.3665C12.095 17.3102 12.1421 17.219 12.1421 17.1218L12.1421 0.871001C12.1421 0.530015 11.6637 0.453326 11.5571 0.777228L9.46214 7.14383C9.42164 7.26689 9.30672 7.35005 9.17717 7.35005L0.886486 7.35005C0.605196 7.35005 0.47858 7.70236 0.695515 7.88142L7.57818 13.5625C7.67808 13.6449 7.71377 13.7822 7.66668 13.9029L4.49514 22.0303C4.38686 22.3078 4.70541 22.5564 4.94828 22.384L12.0157 17.3665Z",
    fill: "#F8CF46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellowHalf);
export default __webpack_public_path__ + "static/media/starYellowHalf.1ef6c13a24d3d3d20d583385c439a311.svg";
export { ForwardRef as ReactComponent };